var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advantage c-width",class:{ interact: _vm.isInteract }},_vm._l((_vm.advantageData),function(item,index){return _c('img',{key:index,class:{ on: item.flag === _vm.selectFlag },attrs:{"src":item.src,"alt":"","width":"570","height":"297"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }